import { BASE_URL } from "@/constants/config";
import { request } from "@/utils/request";

export const FILE_TYPES_ENDPOINTS = {
  file_types_list: `${BASE_URL}api/file_types/`,
  export: `${BASE_URL}api/file_types/export`,
  file_type_details: (file_types_id) => `${BASE_URL}api/file_types/${file_types_id}`,
  file_type_download_url: (template_name) => `${BASE_URL}api/file_types/download/${template_name}`,
};

class FileTypes {
  async getFileTypes() {
    const { data } = await request({
      url: FILE_TYPES_ENDPOINTS.file_types_list,
      query: {
        per_page: 9999,
      }
    });
    return data;
  }

  async createFileType(fileTypeData) {
    const { data } = await request({
      url: FILE_TYPES_ENDPOINTS.file_types_list,
      method: "POST",
      body: fileTypeData,
    });
    return data;
  }

  async updateFileType(file_type_id, fileTypeData) {
    const { data } = await request({
      url: FILE_TYPES_ENDPOINTS.file_type_details(file_type_id),
      method: "PUT",
      body: fileTypeData,
    });
    return data;
  }

  async deleteFileType(file_type_id) {
    const { data } = await request({
      url: FILE_TYPES_ENDPOINTS.file_type_details(file_type_id),
      method: "DELETE",
    });
    return data;
  }
}

export const FileTypesServices = new FileTypes();
